export default {
  label: {
    createAcct: 'người sáng lập',
    createTime: 'Thời gian sáng tạo',
    merchantNo: 'số doanh nghiệp',
    updateAcct: 'người cập nhật',
    updateTime: 'Cập nhật thời gian',
    walletAmount: 'Số tiền trên ví',
    walletType: 'Loại ví',
    momo: 'Momo',
    zalo: 'Zalo',
    vtp: 'Viettel pay',
    vtpFix: 'Viettel pay fix',
    bankOnline: 'Bank online',
    transfer: 'Bank transfer',
    bankQr: 'Bank QR',
    all: 'All',
    card: 'Card',
    payout: 'Payout',
    allMerchantBalance: 'Tổng số dư của người bán',
    todayPayoutAmount: 'Số tiền giao dịch hôm nay',
    todayBalanceAmount: 'Số tiền rút',
    todayTradeAmount: 'Sự cân bằng',
    yesterdayTradeAmount: 'Số tiền giao dịch ngày hôm qua',
    usdtBalance: 'ví usdt'
  },
  rules: {
    walletType: 'Loại ví không được để trống!'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/merchantBalance.js